const ru = {
  // Common & UI
  'app.name': 'ЭНЗП',
  'common.loading': 'Загрузка...',
  'common.save': 'Сохранить',
  'common.cancel': 'Отмена',
  'common.delete': 'Удалить',
  'common.edit': 'Редактировать',
  'common.add': 'Добавить',
  'common.create': 'Создать',
  'common.close': 'Закрыть',
  'common.back': 'Назад',
  'common.search': 'Поиск',
  'common.clear': 'Очистить',
  'common.confirm': 'Подтвердить',
  'common.view': 'Просмотр',
  'common.download': 'Скачать',
  'common.upload': 'Загрузить',
  'common.sign': 'Подписать',
  'common.actions': 'Действия',
  'common.status': 'Статус',
  'common.date': 'Дата',
  'common.time': 'Время',
  'common.id': 'ID',
  'common.number': 'Номер',
  'common.name': 'Название',
  'common.description': 'Описание',
  'common.author': 'Автор',
  'common.branch': 'Филиал',
  'common.yes': 'Да',
  'common.no': 'Нет',
  'common.all': 'Все',
  'common.filter': 'Фильтр',
  'common.reset': 'Сбросить',
  'common.required_field': 'Заполните поле',
  'common.enter_name': 'Введите название',
  'common.proceed': 'ПЕРЕЙТИ',
  'common.photo': 'ФОТО',
  'common.post': 'Запостить',
  'common.comment': 'Комментировать',
  'common.write_comment': 'Написать комментарий...',
  'common.attach_files': 'Прикрепить файл(ы)',
  'common.notifications': 'Уведомления',
  'common.success': 'Успешно',
  'common.error': 'Ошибка',
  'common.warning': 'Предупреждение',
  'common.info': 'Информация',
  'common.empty': 'Нет данных',
  'common.fio': 'ФИО',
  'common.position': 'Должность',
  'common.phone': 'Телефон',
  'common.email': 'Email',
  'common.start': 'Начало',
  'common.end': 'Конец',
  'common.details': 'Подробнее',
  'filter.process': 'Процесс',
  'filter.object': 'Объект',
  'filter.work_type': 'Вид работы',

  // Navigation
  'nav.main': 'Главная',
  'nav.create_task': 'Создать Наряд-задание',
  'nav.create_task_old': 'Создать наряд (старый)',
  'nav.electro_journal': 'Наряд-допуск (электро)',
  'nav.non_electro_journal': 'Наряд-допуск (не электро)',
  'nav.operation': 'Распоряжение',
  'nav.current_operation': 'Работа в порядке текущей эксплуатации',
  'nav.ppr': 'График ППР',
  'nav.weather_journal': 'Журнал погоды',
  'nav.smax_journal': 'Журнал СМАКС',
  'nav.users': 'Пользователи',
  'nav.instructions': 'Инструкции',
  'nav.references': 'Справочник',
  'nav.processes': 'Виды процессов',
  'nav.reports': 'Отчеты',
  'nav.download_playmarket': 'Скачать с PlayMarket',
  'nav.download_appstore': 'Скачать с AppStore',

  // Reports
  'report.title': 'Отчеты и выгрузка статистики',
  'report.user_activity_stat': 'Статистика активности пользователей',
  'report.works_journal': 'Журнал учета работ',
  'report.general_dynamics': 'Общая динамика',
  'report.filials_dynamics': 'Динамика по филиалам',
  'report.work_types_stat': 'Статистика по видам работ',
  'report.filials_tasktypes_stat': 'Статистика филиалов по видам работ',
  'report.visiting_works_report': 'Отчёт по выездным работам',
  'report.smax_summary_report': 'Сводный отчёт по SMAX',
  'report.med_inspection_info': 'Информация о мед. осмотре',
  'report.select_year': 'Выбрать год',
  'report.select_branch': 'Выбрать филиал',
  'report.select_date': 'Выберите дату!',
  'report.select_year_error': 'Выберите год!',
  'report.select_branch_error': 'Выберите филиал!',
  'report.download_success': 'Отчет успешно скачан!',
  'report.download_error': 'Не удалось скачать отчет!',

  // Header
  'header.edit_photo': 'Изменить фото',
  'header.logout': 'Выйти из системы',
  'header.admin': 'Администратор Системы',
  'header.photo_updated': 'Пользователь успешно изменен!',
  'header.photo_format_warning': 'Файл должен быть в формате JPEG/PNG!',
  'header.choose_photo': 'Выберите фото',

  // Breadcrumbs / Work Types
  'breadcrumb.home': 'Главная',
  'breadcrumb.processes': 'Процессы',
  'breadcrumb.objects': 'Объекты процесса',
  'breadcrumb.technologies': 'Вид технологий',
  'breadcrumb.zones': 'Зона обслуживания',
  'breadcrumb.conditions': 'Условия',
  'breadcrumb.task_types': 'Вид работ',
  'breadcrumb.operations': 'Список операций',
  'breadcrumb.edit_task_group': 'РЕДАКТИРОВАТЬ ГРУППУ РАБОТ',

  // Task Creation
  'create_task.title': 'Создать Наряд-задание',
  'create_task.task_type': 'Вид задания',
  'create_task.task_type_placeholder': 'Выберите вид задания',
  'create_task.process': 'Процесс',
  'create_task.process_placeholder': 'Выберите процесс',
  'create_task.object': 'Объект',
  'create_task.object_placeholder': 'Выберите объект',
  'create_task.zone': 'Зона обслуживания',
  'create_task.zone_placeholder': 'Выберите зону обслуживания',
  'create_task.condition': 'Условия производства',
  'create_task.condition_placeholder': 'Выберите условия производства',
  'create_task.work_type': 'Вид работ',
  'create_task.work_type_placeholder': 'Выберите вид работ',
  'create_task.other_work_type': 'ВИД РАБОТЫ ПРЕДЛОЖЕННЫЙ СОТРУДНИКОМ',
  'create_task.access_denied': 'Отказ доступа',
  'create_task.access_denied_reason': 'Запрет на создание наряда. Причина: Согласно сведений 1С, ваш статус: ',

  // Statuses
  'status.created': 'Создано',
  'status.issued': 'Выдан',
  'status.received_for_work': 'Получена в работу',
  'status.on_route': 'В пути',
  'status.suspended': 'Приостановлен',
  'status.completed_without_eds': 'Завершен без подтверждения ЭЦП',
  'status.in_progress': 'В работе',
  'status.rejected': 'Отклонено',
  'status.finished': 'Завершено',
  'status.draft': 'Черновик',
  'status.on_approval': 'На согласовании',
  'status.on_signature': 'На подписи',
  'status.signed': 'Подписан',
  'status.active': 'Действует',
  'status.closed': 'Закрыт',
  'status.sick': 'Болеет',
  'status.vacation': 'В ежегодном отпуске',
  'status.business_trip': 'В командировке',
  'status.dismissed': 'Уволен',
  'status.working': 'Работает',
  'status.finished_from_smax': 'Завершено в SMAX',
  'status.transfer': 'Переназначен',

  // Tables & Journals
  'table.created': 'СОЗДАНА',
  'table.place_and_name': 'Место и наименование работы',
  'table.specified_time': 'Указанное время работы',
  'table.start_date': 'Дата начало',
  'table.end_date': 'Дата завершение',
  'table.started_at': 'К работе приступили (дата, время)',
  'table.finished_at': 'Работа закончена (дата, время)',
  'table.department': 'ПОДРАЗДЕЛЕНИЕ',
  'table.status': 'СТАТУС',
  'table.created_by': 'Кем создано',
  'table.participants': 'Участники',
  'table.all_branches': 'Все филиалы',
  'table.work_name': 'Название работы',
  'table.work_place': 'Где проводятся работы',
  'table.completion_form': 'Способ завершения',
  'table.category': 'Категория',
  'table.task_form': 'Вид заданий',
  'table.created_at': 'Дата создания',
  'table.updated_at': 'Дата обновления',
  'table.responsible': 'Ответственный',
  'table.executor': 'Производитель',
  'table.team_members': 'Члены бригады',
  'table.empty': 'Нет данных',
  'table.actions': 'Действия',
  'table.view': 'Просмотр',
  'table.sign': 'Подписать',
  'table.cancel_task': 'Отменить наряд',
  'table.select_branch': 'Выбрать филиал',
  'table.select_status': 'Выбрать статус',
  'table.search_placeholder': 'Поиск...',
  'table.contingent': 'Контингент',
  'table.current_status': 'Текущий статус',
  'common.age': 'Возраст',
  'common.none': 'Отсутствует',
  'common.file': 'Файл',
  'table.contacts': 'Контакты',
  'table.admission_group': 'Группа допуска',
  'table.issuer': 'Лицо, отдавшее наряд, распоряжение',
  'table.briefed_by': 'Ознакомил с заданием / Провел инструктаж',
  'table.work_producer_or_observer': 'Производитель работ или наблюдающий',
  'table.briefed_acknowledged': 'С условием работы ознакомлен. Получил инструктаж',
  'table.team_members_by_order': 'Члены бригады, работающей по распоряжению',
  'table.work_type': 'Вид работ',
  'table.process': 'Процесс',
  'table.object': 'Объект',
  'table.zone': 'Зона',
  'table.conditions': 'Условия',
  'table.doc_name': 'Наименование документа',
  'table.operation': 'Операция',
  'table.process_name': 'Название процесса',
  'table.technology_name': 'Название технологий',
  'table.zone_name': 'Название зоны обслуживания',
  'table.requested_for': 'Для кого запрошено',
  'table.issue_text': 'Текст проблемы',
  'table.issue_description': 'Описание проблемы',
  'table.slt_time_left': 'Оставшееся SLT время',
  'table.smax_status': 'Статус в SMAX',
  'table.phone_numbers': '№ телефонов',
  'table.line_data': 'Линейные данные',
  'table.work_time': 'Время работы',
  'table.finished': 'Завершено',
  'table.damage_type': 'Характер повреждения',
  'table.reported': 'Заявлено',
  'table.discovered': 'Обнаружено',
  'table.consumption': 'Расход',
  'table.linked_task': 'Связанный наряд',
  'table.link': 'Ссылка',
  'table.key': 'Ключ',

  // Feed
  'feed.live_feed': 'Живая лента',
  'feed.write_post': 'Написать пост',
  'feed.placeholder_write_post': 'Написать пост...',
  'feed.edit_post': 'Редактировать пост',
  'feed.delete_post': 'Удалить пост',
  'feed.no_posts': 'Постов пока нет',

  // Phrases direct mapping
  'Главная': 'Главная',
  'Создать Наряд-задание': 'Создать Наряд-задание',
  'Создать наряд (старый)': 'Создать наряд (старый)',
  'Наряд-допуск (электро)': 'Наряд-допуск (электро)',
  'Наряд-допуск (не электро)': 'Наряд-допуск (не электро)',
  'Распоряжение': 'Распоряжение',
  'Работа в порядке текущей эксплуатации': 'Работа в порядке текущей эксплуатации',
  'График ППР': 'График ППР',
  'Журнал погоды': 'Журнал погоды',
  'Журнал СМАКС': 'Журнал СМАКС',
  'Пользователи': 'Пользователи',
  'Инструкции': 'Инструкции',
  'Справочник': 'Справочник',
  'Виды процессов': 'Виды процессов',
  'Отчеты': 'Отчеты',
  'СОЗДАНА': 'СОЗДАНА',
  'Место и наименование работы': 'Место и наименование работы',
  'Указанное время работы': 'Указанное время работы',
  'Дата начало': 'Дата начало',
  'Дата завершение': 'Дата завершение',
  'К работе приступили (дата, время)': 'К работе приступили (дата, время)',
  'Работа закончена (дата, время)': 'Работа закончена (дата, время)',
  'ПОДРАЗДЕЛЕНИЕ': 'ПОДРАЗДЕЛЕНИЕ',
  'СТАТУС': 'СТАТУС',
  'Кем создано': 'Кем создано',
  'Участники': 'Участники',
  'Фильтр': 'Фильтр',
  'Нет данных': 'Нет данных',
  'Нет данных.': 'Нет данных.',
  'Запостить': 'Запостить',
  'Отменить': 'Отменить',
  'Изменить': 'Изменить',
  'Удалить': 'Удалить',
  'Сохранить': 'Сохранить',
  'Подписать': 'Подписать',
  'Просмотр': 'Просмотр',
  'Написать пост...': 'Написать пост...',
  'Написать комментарий...': 'Написать комментарий...',
  'Прикрепить файл(ы)': 'Прикрепить файл(ы)',
  'Живая лента': 'Живая лента',
  'Создано': 'Создано',
  'Выдан': 'Выдан',
  'Получена в работу': 'Получена в работу',
  'В пути': 'В пути',
  'Приостановлен': 'Приостановлен',
  'Завершен без подтверждения ЭЦП': 'Завершен без подтверждения ЭЦП',
  'В работе': 'В работе',
  'Отклонено': 'Отклонено',
  'Завершено': 'Завершено',
  'Добавить': 'Добавить',
  'Очистить': 'Очистить',
  'Поиск': 'Поиск',
  'Действия': 'Действия',
  'Номер': 'Номер',
  'Номер наряда': 'Номер наряда',
  'ФИО': 'ФИО',
  'Должность': 'Должность',
  'Филиал': 'Филиал',
  'Подразделение': 'Подразделение',
  'Уведомление': 'Уведомление',
  'Успешно': 'Успешно',
  'Ошибка': 'Ошибка',
  'Предупреждение': 'Предупреждение',

  // Auth & System
  'auth.login_title': 'Вход в систему',
  'auth.email_placeholder': 'Введите Email',
  'auth.password_placeholder': 'Введите пароль',
  'auth.email_required': 'Введите Email',
  'auth.password_required': 'Введите Пароль',
  'auth.sign_in': 'Войти',
  'auth.invalid_password': 'Неверный пароль!',
  'auth.user_not_found': 'Пользователь не найден!',
  'auth.login_error': 'Ошибка авторизации',

  // Task Draft & Form
  'task.draft_saved': 'Черновик наряда сохранен',
  'task.draft_restored': 'Черновик наряда успешно восстановлен',
  'task.draft_cleared': 'Черновик очищен',
  'task.clear_draft': 'Очистить форму',
  'task.auto_saved': 'Автосохранение активно',

  // Modals
  'modal.sign_title': 'Подписание наряда',
  'modal.cancel_title': 'Отмена наряда',
  'modal.confirm_sign': 'Вы действительно хотите подписать?',
  'modal.confirm_cancel': 'Вы уверены, что хотите отменить наряд?',
  'modal.enter_reason': 'Укажите причину',
  'modal.reason_required': 'Пожалуйста, укажите причину',

  // Operation Modals
  'operation.sign_order_title': 'Подписание наряд-задания',
  'operation.action_required': 'Требуется действие',
  'operation.confirm_sign': 'Подтвердите действие с помощью ключа ЭЦП',
  'operation.ecp_key_file': 'Файл ключа ЭЦП (RSA / GOST / .p12):',
  'operation.change_ecp': 'Выбрать другой ключ',
  'operation.upload_ecp': 'Загрузить файл ЭЦП',
  'operation.select_ecp_file': 'Пожалуйста, выберите файл ЭЦП',
  'operation.file_read_error': 'Ошибка чтения файла ЭЦП',
  'operation.ecp_password': 'Пароль от ЭЦП:',
  'operation.enter_ecp_password': 'Введите пароль от сертификата ЭЦП',
  'operation.sign_btn': 'Подписать',
  'operation.cancel_order_title': 'Отклонение наряд-задания',
  'operation.cancel_warning_title': 'Внимание!',
  'operation.cancel_warning_desc': 'Отклонение наряда является необратимым действием. Укажите причину и подпишите ключом ЭЦП.',
  'operation.cancel_reason_label': 'Причина отказа:',
  'operation.cancel_reason_placeholder': 'Подробно укажите причину отказа...',
  'operation.cancel_reason_required': 'Напишите причину отказа наряда!',
  'operation.cancel_success': 'Наряд успешно отклонен',
  'operation.reject_btn': 'Отклонить наряд',
  'operation.order_info_title': 'Информация о наряд-задании',
  'operation.process': 'Процесс',
  'operation.technology': 'Технология',
  'operation.service_zone': 'Зона обслуживания',
  'operation.conditions': 'Условия',
  'operation.work_type': 'Вид работы',
  'operation.entrusted': 'Поручается',
  'operation.completion_form': 'Форма завершения',
  'operation.other_task_name': 'Название',
  'operation.visiting_work': 'Выездная работа',
  'operation.visiting_work_other': 'Выездная работа (др.)',
  'operation.driver': 'Водитель',
  'operation.photo_confirmation': 'Фотофиксация завершения',
  'operation.photo_attached': 'К наряду прикреплен подтверждающий фотоматериал',
  'operation.view_photo': 'Посмотреть фото',
  'operation.sms_confirmation': 'SMS Подтверждение',
  'operation.sms_no_confirm_reason': 'Без подтверждения. Причина:',
  'operation.sms_sent_to': 'SMS на номер:',
  'operation.sms_time': 'Время:',
  'operation.sms_code': 'Код:',
  'operation.status_history': 'История изменения статусов',
  'operation.status_before': 'Статус до',
  'operation.status_after': 'Статус после',
  'operation.datetime': 'Дата и время',
  'operation.operations_list': 'Список операций',
  'operation.operation_name': 'Наименование операции',
  'operation.gps_track_title': 'GPS Трек сотрудников',
  'operation.select_employees_track': 'Выберите сотрудников для отображения трека:',
  'operation.signature_verification_title': 'Результаты проверки ЭЦП',
  'operation.download_sig_file': 'Скачать файл подписи',
  'operation.signer': 'Подписант',
  'operation.iin': 'ИИН:',
  'operation.cert_check': 'Проверка сертификата',
  'operation.tsp_check': 'Проверка TSP (Штамп времени)',
  'operation.sig_check': 'Проверка подписи',
  'operation.valid': 'Действителен (Успешно)',
  'operation.invalid': 'Не успешно',
  'operation.cert_serial': 'Серийный номер',
  'operation.cert_validity': 'Срок действия',
  'operation.cert_template': 'Шаблон сертификата',
  'operation.signed_date': 'Дата подписания',
  'operation.comments_modal_title': 'Замечания и комментарии к наряду',

  // User Profile & Drawer
  'user.profile_title': 'Карточка сотрудника',
  'user.add_title': 'Добавить пользователя',
  'user.edit_title': 'Редактировать пользователя',
  'user.general_info': 'Основная информация',
  'user.contacts': 'Контактная информация',
  'user.safety_and_qualifications': 'Допуски и безопасность',
  'user.email_label': 'Корпоративная почта (Email)',
  'user.branch_label': 'Организация / Филиал',
  'user.division_label': 'Структурное подразделение',
  'user.position_label': 'Должность',
  'user.iin_label': 'ИИН',
  'user.birthdate_label': 'Дата рождения',
  'user.started_working_label': 'Дата приема на работу',
  'user.role_label': 'Пользовательская роль',
  'user.status_employee_label': 'Статус сотрудника',
  'user.active_status_label': 'Статус учетной записи',
  'user.phone_work_label': 'Рабочий телефон (стационарный)',
  'user.phone_work_mobile_label': 'Рабочий мобильный',
  'user.phone_personal_label': 'Личный мобильный',
  'user.electr_group_label': 'Группа допуска по электробезопасности',
  'user.electr_admission_date_label': 'Дата подтверждения допуска',
  'user.safety_date_label': 'Дата сдачи экзамена по БиОТ',
  'user.medical_passed_label': 'Медицинский осмотр',
  'user.medical_date_label': 'Дата медосмотра',
  'user.is_emerg_repair_staff_label': 'Оперативно-ремонтный персонал',
  'user.admission_height_label': 'Допуск к работам на высоте',
  'user.prof_suitable_label': 'Профпригодность к работам',
  'user.contingent_label': 'Контингент',
  'user.role_central': 'Центральный аппарат',
  'user.role_admin_system': 'Администратор системы',
  'user.role_admin_branch': 'АУП Филиала',
  'user.role_issuer': 'Выдающий наряд',
  'user.role_executor': 'Исполнитель заданий',
  'user.group_none': 'Отсутствует',
  'user.group_1': 'I группа',
  'user.group_2': 'II группа',
  'user.group_3': 'III группа',
  'user.group_4': 'IV группа',
  'user.group_5': 'V группа',
  'user.fit': 'Годен',
  'user.unfit': 'Не годен',
  'user.passed': 'Пройден',
  'user.not_passed': 'Не пройден',
  'user.copied': 'Скопировано в буфер обмена'
};

export default ru;
